import React from 'react';

const Home = (props) => {  

    return (
        <div className="content">          

            <h2>What would you like to do?</h2>
            <div className="padded">
                <a href="new" className="link-small">Start a new DUC</a><br />
                <p>Complete a new DUC for your subject site.</p>
                <a href="update" className="link-small">Update an existing DUC</a>
                <p>Update or complete your DUC.</p>
                <a href="recall" className="link-small">Recall an existing DUC</a>
                <p>Review the summary of a DUC you have completed before.</p>
            </div>
            <p>For more information about the design of the DUC Tool and how we keep it anonymous, see the <strong><a href="https://ltc.uow.edu.au/hub/page/duc">Digital Uplift Check (DUC) Tool</a></strong> page on the L&T Hub.</p>
        
        </div>

    );
  
}


export default Home;
